import axios from 'axios'

export default () => {
    return {
        sites: '',

        proxy: null,
        api: {
            foundation: '',
            teams: '',
            college: '',
            homes: '',
            marriage: '',
            leadership: '',
            press: '',
        },

        perPage: 12,
        collection: '',

        siteData: {
            foundation: {
                page: 1,
                finished: false,
                running: false,
                itemsFetched: 0,
            },
            teams: {
                page: 1,
                finished: false,
                running: false,
                itemsFetched: 0,
            },
            college: {
                page: 1,
                finished: false,
                running: false,
                itemsFetched: 0,
            },
            homes: {
                page: 1,
                finished: false,
                running: false,
                itemsFetched: 0,
            },
            marriage: {
                page: 1,
                finished: false,
                running: false,
                itemsFetched: 0,
            },
            retreat: {
                page: 1,
                finished: false,
                running: false,
                itemsFetched: 0,
            },
            leadership: {
                page: 1,
                finished: false,
                running: false,
                itemsFetched: 0,
            },
            press: {
                page: 1,
                finished: false,
                running: false,
                itemsFetched: 0,
            },
        },

        items: [],
        pinnedEntries: null,
        pinnedItems: [],

        search: null,

        filters: {
            topic: {
                selected: 'all',
                selections: [],
            },
            stageoflife: {
                selected: 'all',
                selections: [],
            },
            author: {
                selected: 'all',
                selections: [],
            },
            sort: {
                selected: 'date_dsc',
            },
            medium: {
                selected: 'all',
                selections: [],
            },
        },

        filtered: true,

        aggregatedData: {
            totalAPI: 0,
            finishedAPI: 0,
        },

        finished: false,

        // π ----
        // :: MOUNTED ---------------------------::
        // ____
        async mounted() {
            Object.keys(this.api).forEach((key, value) => {
                let ministry = ''

                if (key !== 'foundation') {
                    ministry = `${key}.`
                }

                // If on staging, use staging API URLs instead of production
                let baseUrl = this.proxy // normally "winshape.org"
                if (window.location.hostname.includes('wsfoundstage')) {
                    baseUrl = 'wsfoundstage.wpengine.com'
                }

                this.api[key] = `https://${ministry}${baseUrl}/wp-admin/admin-ajax.php`
            })

            await this.fetchPinnedEntries()
            this.fetchInit()
            this.filterInit()
        },

        // π ----
        // :: FETCH INIT ---------------------------::
        // ____
        fetchInit() {
            if (this.sites === 'all') {
                this.fetchAllSites()
            } else if (this.sites === 'foundation') {
                this.fetchEntries(this.api.foundation, this.sites)
            } else if (this.sites === 'teams') {
                this.fetchEntries(this.api.teams, this.sites)
            } else if (this.sites === 'college') {
                this.fetchEntries(this.api.college, this.sites)
            } else if (this.sites === 'homes') {
                this.fetchEntries(this.api.homes, this.sites)
            } else if (this.sites === 'marriage') {
                this.fetchEntries(this.api.marriage, this.sites)
            } else if (this.sites === 'leadership') {
                this.fetchEntries(this.api.leadership, this.sites)
            } else if (this.sites === 'retreat') {
                this.fetchEntries(this.api.retreat, this.sites)
            } else if (this.sites === 'press') {
                this.fetchEntries(this.api.press, this.sites)
            }
        },

        openGrid() {
            const open = gsap.timeline()

            open.to(this.$refs.cardGrid, {
                duration: 0.5,
                height: this.$refs.cardGrid.scrollHeight,
                ease: 'quint.inOut',
            }).to(
                this.$refs.gridCover,
                {
                    duration: 0.3,
                    autoAlpha: 0,
                    onComplete: () => ScrollTrigger.refresh(),
                },
                '<0.3',
            )
        },

        closeGrid() {
            const close = gsap.timeline()
            close.to(this.$refs.gridCover, { duration: 0.3, autoAlpha: 1 }).to(
                this.$refs.cardGrid,
                {
                    duration: 0.5,
                    height: 180,
                    ease: 'quint.inOut',
                    onComplete: () => ScrollTrigger.refresh(),
                },
                '<0',
            )
        },

        // π ----
        // :: FETCH ENTRIES ---------------------------::
        // ____
        fetchEntries(apiURL, apiName) {
            const requestData = new FormData()
            const pageNumber = this.getPage(apiName)
            const perPageCount = this.getPerPageCount()
            const offset = this.siteData[apiName].itemsFetched
            const pinnedCount = this.pinnedItems ? this.pinnedItems.length : 0

            requestData.append('action', 'resourceFetch')
            requestData.append('collection', this.collection)
            requestData.append('page', pageNumber)
            requestData.append('offset', offset)
            requestData.append('per_page', perPageCount)

            // :: Exclude Pinned IDs ------------ //
            if (this.pinnedItems && this.pinnedItems.length > 0) {
                const pinnedIds = this.pinnedItems.map(item => item.id)
                requestData.append('exclude_ids', JSON.stringify(pinnedIds))
            }

            // :: Filters ------------ //
            requestData.append('filter_topic', this.filters.topic.selected)
            requestData.append('filter_stageoflife', this.filters.stageoflife.selected)
            requestData.append('filter_author', this.filters.author.selected)
            requestData.append('filter_medium', this.filters.medium.selected)
            requestData.append('filter_sort', this.filters.sort.selected)
            if (this.search) {
                requestData.append('search_term', this.search)
            }

            this.anyMore(apiURL, apiName)

            axios
                .post(apiURL, requestData)
                .then(response => {
                    if (response.data.entries != '') {
                        const entries = response.data.entries

                        if (this.filtered) {
                            this.items = entries
                            this.filtered = false
                        } else {
                            const mergedItems = this.items.concat(entries)
                            this.items = mergedItems
                        }

                        if (this.sites === 'all') {
                            this.logAPI(apiName)
                        }

                        this.siteData[apiName].itemsFetched += entries.length
                        this.updatePage(apiName)
                    } else {
                        this.finishedFetch(apiName)
                    }

                    setTimeout(() => {
                        this.openGrid()
                    }, 200)
                })
                .catch(error => {
                    console.log(error)
                })
        },

        // π ----
        // :: FETCH FROM ALL SITES ---------------------------::
        // ____
        fetchAllSites() {
            const APIs = Object.entries(this.api)

            for (const [apiName, siteAPI] of APIs) {
                if (apiName !== 'press') {
                    this.fetchEntries(siteAPI, apiName)
                }
            }
        },

        // π ----
        // :: FETCH PINNED ENTRIES ---------------------------::
        // ____
        fetchPinnedEntries() {
            if (!this.pinnedEntries || !Array.isArray(this.pinnedEntries) || this.pinnedEntries.length === 0) {
                return Promise.resolve()
            }

            // Parse pinnedEntries to extract sites and IDs
            const siteMap = {}
            this.pinnedEntries.forEach(entry => {
                const parts = entry.split('_')
                if (parts.length === 2) {
                    const site = parts[0]
                    const id = parts[1]
                    if (!siteMap[site]) {
                        siteMap[site] = []
                    }
                    siteMap[site].push(id)
                }
            })

            const sites = Object.keys(siteMap)

            // Call local proxy to fetch pinned entries
            const requestData = new FormData()
            requestData.append('action', 'fetch_pinned_entries')
            requestData.append('sites', JSON.stringify(sites))
            requestData.append('collection', this.collection)
            requestData.append('template', 'resources')
            requestData.append('pinned_ids', JSON.stringify(this.pinnedEntries))

            return axios.post('/wp-admin/admin-ajax.php', requestData)
                .then(response => {
                    if (response.data.success && response.data.data.entries) {
                        this.pinnedItems = response.data.data.entries
                    }
                })
        },

        // π ----
        // :: GET DISPLAY ITEMS (PINNED + REGULAR) ---------------------------::
        // ____
        getDisplayItems() {
            if (!this.pinnedItems || this.pinnedItems.length === 0) {
                return this.items
            }

            // Only show pinned items when using default filters
            if (!this.isDefaultFilters()) {
                return this.items
            }

            // Create a set of pinned IDs for quick lookup
            const pinnedIds = new Set(this.pinnedItems.map(item => item.id))

            // Filter out any regular items that are also pinned (deduplicate)
            const regularItems = this.items.filter(item => !pinnedIds.has(item.id))

            // Combine: pinned first, then regular
            return [...this.pinnedItems, ...regularItems]
        },

        // π ----
        // :: CHECK IF USING DEFAULT FILTERS ---------------------------::
        // ____
        isDefaultFilters() {
            return this.filters.topic.selected === 'all' &&
                this.filters.stageoflife.selected === 'all' &&
                this.filters.author.selected === 'all' &&
                this.filters.medium.selected === 'all' &&
                this.filters.sort.selected === 'date_dsc' &&
                (!this.search || this.search === '')
        },

        // π ----
        // :: GET PER PAGE COUNT (ACCOUNTING FOR PINNED) ---------------------------::
        // ____
        getPerPageCount() {
            const isInitialLoad = this.items.length === 0
            const isDefault = this.isDefaultFilters()
            const pinnedCount = this.pinnedItems ? this.pinnedItems.length : 0

            if (isDefault && isInitialLoad && this.pinnedItems && this.pinnedItems.length > 0) {
                return this.perPage - this.pinnedItems.length
            }

            return this.perPage
        },

        // π ----
        // :: CHECK IF THERE ARE ANYMORE ENTRIES ---------------------------::
        // ____
        anyMore(apiURL, apiName) {
            const requestData = new FormData()
            const pageNumber = this.getPage(apiName) + 1

            requestData.append('action', 'resourceFetch')
            requestData.append('collection', this.collection)
            requestData.append('page', pageNumber)
            requestData.append('per_page', this.perPage)

            // :: Filters ------------ //
            requestData.append('filter_topic', this.filters.topic.selected)
            requestData.append('filter_stageoflife', this.filters.stageoflife.selected)
            requestData.append('filter_author', this.filters.author.selected)
            requestData.append('filter_medium', this.filters.medium.selected)
            requestData.append('filter_sort', this.filters.sort.selected)
            if (this.search) {
                requestData.append('search_term', this.search)
            }

            axios
                .post(apiURL, requestData)
                .then(response => {
                    if (response.data.entries == '') {
                        this.finishedFetch(apiName)
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },

        // π ----
        // :: GET A SITE'S COLLECTION PAGE NUMBER ---------------------------::
        // ____
        getPage(site) {
            if (site === 'foundation') {
                return this.siteData.foundation.page
            } else if (site === 'teams') {
                return this.siteData.teams.page
            } else if (site === 'college') {
                return this.siteData.college.page
            } else if (site === 'homes') {
                return this.siteData.homes.page
            } else if (site === 'marriage') {
                return this.siteData.marriage.page
            } else if (site === 'leadership') {
                return this.siteData.leadership.page
            } else if (site === 'press') {
                return this.siteData.press.page
            }
        },

        // π ----
        // :: UPDATE A SITE'S COLLECTION PAGE NUMBER ---------------------------::
        // ____
        updatePage(site) {
            if (site === 'foundation') {
                this.siteData.foundation.page += 1
            } else if (site === 'teams') {
                this.siteData.teams.page += 1
            } else if (site === 'college') {
                this.siteData.college.page += 1
            } else if (site === 'homes') {
                this.siteData.homes.page += 1
            } else if (site === 'marriage') {
                this.siteData.marriage.page += 1
            } else if (site === 'leadership') {
                this.siteData.leadership.page += 1
            } else if (site === 'press') {
                this.siteData.press.page += 1
            }
        },

        // π ----
        // :: LOG API FOR "ALL" SITES ---------------------------::
        // ____
        logAPI(currentAPI) {
            if (currentAPI === 'foundation' && this.siteData.foundation.running === false) {
                this.siteData.foundation.running = true
                this.aggregatedData.totalAPI += 1
            } else if (currentAPI === 'teams' && this.siteData.teams.running === false) {
                this.siteData.teams.running = true
                this.aggregatedData.totalAPI += 1
            } else if (currentAPI === 'college' && this.siteData.college.running === false) {
                this.siteData.college.running = true
                this.aggregatedData.totalAPI += 1
            } else if (currentAPI === 'homes' && this.siteData.homes.running === false) {
                this.siteData.homes.running = true
                this.aggregatedData.totalAPI += 1
            } else if (currentAPI === 'marriage' && this.siteData.marriage.running === false) {
                this.siteData.marriage.running = true
                this.aggregatedData.totalAPI += 1
            } else if (currentAPI === 'leadership' && this.siteData.leadership.running === false) {
                this.siteData.leadership.running = true
                this.aggregatedData.totalAPI += 1
            }
        },

        // π ----
        // :: FINISHED FETCHING ---------------------------::
        // ____
        finishedFetch(finishedAPI) {
            if (this.sites === 'all') {
                this.markComplete(finishedAPI)
            } else {
                this.finished = true
            }
        },

        // π ----
        // :: MARK API AS COMPLETED ---------------------------::
        // ____
        markComplete(finishedAPI) {
            if (finishedAPI === 'foundation' && this.siteData.foundation.finished === false) {
                this.siteData.foundation.finished = true
                this.aggregatedData.finishedAPI += 1
            } else if (finishedAPI === 'teams' && this.siteData.teams.finished === false) {
                this.siteData.teams.finished = true
                this.aggregatedData.finishedAPI += 1
            } else if (finishedAPI === 'college' && this.siteData.college.finished === false) {
                this.siteData.college.finished = true
                this.aggregatedData.finishedAPI += 1
            } else if (finishedAPI === 'homes' && this.siteData.homes.finished === false) {
                this.siteData.homes.finished = true
                this.aggregatedData.finishedAPI += 1
            } else if (finishedAPI === 'marriage' && this.siteData.marriage.finished === false) {
                this.siteData.marriage.finished = true
                this.aggregatedData.finishedAPI += 1
            } else if (finishedAPI === 'leadership' && this.siteData.leadership.finished === false) {
                this.siteData.leadership.finished = true
                this.aggregatedData.finishedAPI += 1
            } else if (finishedAPI === 'press' && this.siteData.press.finished === false) {
                this.siteData.press.finished = true
                this.aggregatedData.finishedAPI += 1
            }

            this.allDone()
        },

        // π ----
        // :: ALL DONE? ---------------------------::
        // ____
        allDone() {
            if (this.aggregatedData.finishedAPI === this.aggregatedData.totalAPI) {
                this.finished = true
            }
        },

        // π ----
        // :: FILTER INIT ---------------------------::
        // ____
        filterInit() {
            let api

            if (this.sites === 'all') {
                this.fetchAllFilters()
            } else if (this.sites === 'foundation') {
                api = this.api.foundation
            } else if (this.sites === 'teams') {
                api = this.api.teams
            } else if (this.sites === 'college') {
                api = this.api.college
            } else if (this.sites === 'homes') {
                api = this.api.homes
            } else if (this.sites === 'marriage') {
                api = this.api.marriage
            } else if (this.sites === 'leadership') {
                api = this.api.leadership
            } else if (this.sites === 'press') {
                api = this.api.press
            }

            /* :: Load Filters Based on Selected Collection
            {+} ---------------------------------- */
            let taxonomiesToFetch = ['topics', 'stage-of-life', 'medium', 'entry-author']
            
            if (taxonomiesToFetch.length > 0 && api) {
                this.fetchBatchedFilters(api, taxonomiesToFetch)
            }
        },

        fetchBatchedFilters(apiURL, taxonomies) {
            const requestData = new URLSearchParams()
            requestData.append('taxonomies', taxonomies.join(','))
            requestData.append('action', 'resourcesTaxonomies')
            axios
                .post(apiURL, requestData)
                .then(response => {
                    if (response.data) {
                        // Process each taxonomy in the response
                        for (const [taxonomy, terms] of Object.entries(response.data)) {
                            // Skip debug properties
                            if (taxonomy.startsWith('debug_')) continue;

                            let filter

                            if (taxonomy === 'topics') {
                                filter = this.filters.topic.selections
                            } else if (taxonomy === 'stage-of-life') {
                                filter = this.filters.stageoflife.selections
                            } else if (taxonomy === 'medium') {
                                filter = this.filters.medium.selections
                            } else if (taxonomy === 'entry-author') {
                                filter = this.filters.author.selections
                            }

                            if (filter && terms && Array.isArray(terms)) {
                                for (let i = 0; i < terms.length; i++) {
                                    if (terms[i].name) {
                                        filter.push(terms[i])
                                    }
                                }
                            }
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },

        fetchFilters(apiURL, taxonomy) {
            let filter

            if (taxonomy === 'topics') {
                filter = this.filters.topic.selections
            } else if (taxonomy === 'stage-of-life') {
                filter = this.filters.stageoflife.selections
            } else if (taxonomy === 'medium') {
                filter = this.filters.medium.selections
            } else if (taxonomy === 'entry-author') {
                filter = this.filters.author.selections
            }

            const requestData = new FormData()

            requestData.append('taxonomy', taxonomy)
            requestData.append('action', 'resourcesTaxonomies')

            axios
                .post(apiURL, requestData)
                .then(response => {
                    if (response.data) {
                        for (let i = 0; i < response.data.length; i++) {
                            if (response.data[i].name) {
                                filter.push(response.data[i])
                            }
                        }
                    } else {
                        console.log(`There was NO Taxonomy Response`)
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },

        fetchAllFilters() {
            const APIs = Object.values(this.api)

            for (const siteAPI of APIs) {
                this.fetchFilters(siteAPI, 'location')
            }
        },

        // π ----
        // :: FILTER COLLECTION ---------------------------::
        // ____
        /**
         * Once a filter is selected, we need to bind that slug to the appropriate _filter_.
         * Then re-fetch items the filters set through _fetchInit()_.
         */
        filterCollection(filterKey, filterSlug) {
            let newFilter = false

            if (filterKey === 'topic') {
                if (this.filters.topic.selected !== filterSlug) {
                    newFilter = true
                    this.filters.topic.selected = filterSlug
                }
            } else if (filterKey === 'stage-of-life') {
                if (this.filters.stageoflife.selected !== filterSlug) {
                    newFilter = true
                    this.filters.stageoflife.selected = filterSlug
                }
            } else if (filterKey === 'author') {
                if (this.filters.author.selected !== filterSlug) {
                    newFilter = true
                    this.filters.author.selected = filterSlug
                }
            } else if (filterKey === 'medium') {
                if (this.filters.medium.selected !== filterSlug) {
                    newFilter = true
                    this.filters.medium.selected = filterSlug
                }
            } else if (filterKey === 'sort') {
                if (this.filters.sort.selected !== filterSlug) {
                    newFilter = true
                    this.filters.sort.selected = filterSlug
                }
            }

            if (newFilter) {
                this.updateResults()
            }
        },

        updateResults() {
            this.closeGrid()
            setTimeout(() => {
                this.resetCollection()
                this.filtered = true
                this.fetchInit()
                this.pushUrlFilters()
            }, 600)
        },

        // π ----
        // :: SET URL FILTERS ---------------------------::
        // ____
        pushUrlFilters() {
            if (history.pushState) {
                const root = `${window.location.protocol}//${window.location.host}${window.location.pathname}?`

                /* :: Topic
                {+} ---------------------------------- */
                let topic = ''
                topic = `topic=${this.filters.topic.selected}`

                /* :: Stage of Life
                {+} ---------------------------------- */
                let stageoflife = ''
                topic = `stageoflife=${this.filters.stageoflife.selected}`

                /* :: Author
                {+} ---------------------------------- */
                let author = ''
                author = `author=${this.filters.author.selected}`

                /* :: Medium
                {+} ---------------------------------- */
                let medium = ''
                medium = `medium=${this.filters.medium.selected}`

                /* :: Sort
                {+} ---------------------------------- */
                let sort = ''
                sort = `sort=${this.filters.sort.selected}`

                const divider01 = topic ? '&' : ''
                const divider02 = stageoflife ? '&' : ''
                const divider03 = author ? '&' : ''
                const divider04 = medium ? '&' : ''

                const updatedURL = `${root}${topic}${divider01}${stageoflife}${divider02}${author}${divider03}${medium}${divider04}${sort}`

                window.history.pushState({ path: updatedURL }, '', updatedURL)
            }
        },

        // π ----
        // :: RESET ---------------------------::
        // ____
        /**
         * Resets the _items_ array and each site's _page_
         */
        resetCollection() {
            this.siteData.foundation.page = 1
            this.siteData.foundation.itemsFetched = 0
            this.siteData.teams.page = 1
            this.siteData.teams.itemsFetched = 0
            this.siteData.college.page = 1
            this.siteData.college.itemsFetched = 0
            this.siteData.homes.page = 1
            this.siteData.homes.itemsFetched = 0
            this.siteData.marriage.page = 1
            this.siteData.marriage.itemsFetched = 0
            this.siteData.retreat.page = 1
            this.siteData.retreat.itemsFetched = 0
            this.siteData.leadership.page = 1
            this.siteData.leadership.itemsFetched = 0
            this.siteData.press.page = 1
            this.siteData.press.itemsFetched = 0
            this.finished = false
            this.items = []
        },
    }
}
